'use client';

import { openChat } from '../lib/openChat';

/** CTA de servico: se href for 'chat', abre o assistente em vez de navegar. */
export default function ServicoCta({
  href,
  label,
  className,
}: {
  href: string;
  label: string;
  className?: string;
}) {
  if (href === 'chat') {
    return (
      <a href="#" onClick={openChat} className={className}>
        {label}
      </a>
    );
  }

  return (
    <a href={href} className={className}>
      {label}
    </a>
  );
}
